import { CustomShipmentText } from '@/components';
import type { AlertCompletion } from '@/apis/types';
import { formatCloseDetailHtml } from './cocTimelineMerge';

interface CloseEntryDetailProps {
  completion: AlertCompletion;
}

/**
 * Under a person's Resolve / Dismiss: the tag, a dot, then the quoted
 * comment, which keeps flowing onto the next lines as needed. Nothing is cut,
 * and each part shows only when it exists.
 */
const CloseEntryDetail = ({ completion }: CloseEntryDetailProps) => {
  const html = formatCloseDetailHtml(completion);

  if (!html) return null;

  return (
    <CustomShipmentText
      htmlString={html}
      color='var(--text-light)'
      whiteSpace='pre-line'
      marginTop='2px'
      marginBottom='0px'
      style={{ overflowWrap: 'anywhere' }}
    />
  );
};

export default CloseEntryDetail;
